/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Col, Form, Input, Row, Select } from "antd";

import {
  getAllRegions,
  getBarangay,
  getMunicipality,
  getProvince,
} from "../../http-request/address";
import { getOptions } from "../../../helpers/options";

function PHAddressForm(props) {
  const [regions, setRegions] = useState([]);
  const [province, setProvince] = useState([]);
  const [municipality, setMunicipality] = useState([]);
  const [barangay, setBarangay] = useState([]);

  useEffect(() => {
    getRegions();

    if (props.locationData) {
      loadProvince(props.locationData.regionCode);
      loadMunicipality(props.locationData.provinceCode);
      loadBarangay(props.locationData.municipalityCode);
    }
  }, []);

  const getRegions = async () => {
    await getAllRegions().then((data) => {
      let _regions = getOptions({ data, value: "regCode", label: "regDesc" });
      setRegions(_regions);
    });
  };

  const onChangeRegion = async (value) => {
    props.forms?.setFieldsValue({
      municipality: "",
      barangay: "",
      province: "",
    });
    loadProvince(value);
  };

  const onChangeProvince = async (value) => {
    props.forms?.setFieldsValue({
      municipality: "",
      barangay: "",
    });
    loadMunicipality(value);
  };

  const onChangeMunicipality = async (value) => {
    props.forms?.setFieldsValue({
      barangay: "",
    });
    loadBarangay(value);
  };

  const loadBarangay = async (value) => {
    await getBarangay(value).then((data) => {
      let _provinces = getOptions({
        data,
        value: "brgyCode",
        label: "brgyDesc",
      });
      setBarangay(_provinces);
    });
  };

  const loadProvince = async (value) => {
    await getProvince(value).then((data) => {
      let _provinces = getOptions({
        data,
        value: "provCode",
        label: "provDesc",
      });
      setProvince(_provinces);
    });
  };

  const loadMunicipality = async (value) => {
    await getMunicipality(value).then((data) => {
      let _provinces = getOptions({
        data,
        value: "citymunCode",
        label: "citymunDesc",
      });
      setMunicipality(_provinces);
    });
  };

  return (
    <>
      <Row>
        <Col span={24}>
          <Form.Item
            labelAlign="left"
            name="street"
            label="Street of the business"
            rules={[
              {
                required: true,
                message: "Please input stree address!",
              },
            ]}
          >
            <Input placeholder="Street address, P.O box, business name.. " />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={20}>
        <Col span={12}>
          <Form.Item
            labelAlign="left"
            name="region"
            label="Region"
            rules={[
              {
                required: true,
                message: "Please select a region!",
              },
            ]}
          >
            <Select
              disabled={
                regions.length > 0 || props?.locationData ? false : true
              }
              options={regions}
              onChange={onChangeRegion}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            labelAlign="left"
            name="province"
            label="Province"
            rules={[
              {
                required: true,
                message: "Please select a province!",
              },
            ]}
          >
            <Select
              options={province}
              disabled={
                province.length > 0 || props?.locationData ? false : true
              }
              onChange={onChangeProvince}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Form.Item
            labelAlign="left"
            name="municipality"
            label="Municipality"
            rules={[
              {
                required: true,
                message: "Please select a municipality!",
              },
            ]}
          >
            <Select
              options={municipality}
              disabled={
                municipality.length > 0 || props?.locationData ? false : true
              }
              onChange={onChangeMunicipality}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={20}>
        <Col span={12}>
          <Form.Item
            labelAlign="left"
            name="barangay"
            label="Barangay"
            rules={[
              {
                required: true,
                message: "Please select a barangay!",
              },
            ]}
          >
            <Select
              options={barangay}
              disabled={
                barangay.length > 0 || props?.locationData ? false : true
              }
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            labelAlign="left"
            name="zipCode"
            label="Zip Code"
            rules={[
              {
                required: true,
                message: "Please input Zip Code!",
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
}

export default PHAddressForm;
